// View Dashboard: the routes and the sidebar rows of `wealth.intelligence.view-dashboard` (ADR-0027).
import { Navigate } from 'react-router';
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.intelligence.view-dashboard',
    routes: [
        { frontend: 'view', path: '', lazy: () => import('@/pages/view/page') },
        {
            frontend: 'view',
            path: 'dashboard',
            lazy: () => import('@/pages/view/firm-overview/page'),
        },
        {
            frontend: 'view',
            path: 'firm-overview',
            lazy: () => import('@/pages/view/firm-overview/page'),
        },
        // IFC Governance + ManComm Programme are unwired (issue #208).
        // The page components are kept; saved/direct URLs to these
        // prefixes (and their sub-paths) redirect to the View home
        // rather than to the NotFound page of the layout.
        { frontend: 'view', path: 'ifc/*', element: <Navigate to="/view/firm-overview" replace /> },
        {
            frontend: 'view',
            path: 'mancomm/*',
            element: <Navigate to="/view/firm-overview" replace />,
        },
    ],
    nav: [
        {
            frontend: 'view',
            key: 'firm-overview',
            label: 'View Dashboard',
            href: '/view/dashboard',
            icon: 'LayoutDashboard',
            group: 'overview',
            order: 110,
            aliases: ['/view/firm-overview'],
        },
    ],
});
